var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"intersect",rawName:"v-intersect",value:({
    handler: _vm.onIntersect,
    options: { threshold: [0.1] },
  }),expression:"{\n    handler: onIntersect,\n    options: { threshold: [0.1] },\n  }"}],staticClass:"pt-16 absolute-bottom"})}
var staticRenderFns = []

export { render, staticRenderFns }